<template>
  <el-form-item
    :label="$attrs.label"
    :prop="$attrs.name"
    :picker-options="$attrs.pickeroptions"
    class="elsa-input"
    :ref="$attrs.name"
  >
    <template slot="label" v-if="information">
      {{ $attrs.label }}
      <el-tooltip v-if="information" :content="information" popper-class="white-space-pre-line" placement="top-start">
        <i class="el-icon-info" />
      </el-tooltip>
    </template>
    <el-date-picker v-bind="$attrs" v-model="modelProp" v-on:change="$emit('change')" />
  </el-form-item>
</template>

<script>
export default {
  name: "ElsaInput",
  props: ["value","information"],
  computed: {
    modelProp: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.elsa-input {
  &::v-deep .el-input .el-input__inner {
    background: #ffffff;
    border: 1px solid #e6e6e6;
    box-sizing: border-box;
    border-radius: 8px;
    font-family: "SF Pro Display", sans-serif;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
    opacity: 0.6;
    height: 52px;
    text-indent: 28px;
    width: 88%;
  }
}
</style>
